import { Chip, ChipProps, alpha, styled } from '@mui/material'

const BuilderChip = styled(Chip)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: alpha(theme.palette.brand.appBarContrastText, 0.6),
  backgroundColor: theme.palette.brand.appBarMain,
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shorter
  }),

  '&:hover': {
    opacity: 1,
    backgroundColor: 'inherit'
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: '100%'
  },

  '& svg': {
    flexShrink: 0,
    background: 'transparent !important',
    marginRight: '0 !important',

    '& path': {
      fill: alpha(theme.palette.brand.appBarContrastText, 0.6)
    },
    '& .MuiCircularProgress-circle': {
      stroke: alpha(theme.palette.brand.appBarContrastText, 0.6)
    }
  }
}))

export default function BuilderHeaderChip(props: ChipProps) {
  return <BuilderChip color="primary" size="small" {...props} />
}
